var getSynchronyAssetsURL = function (url) {
    // creating a new URL from the one we receive to not modify the original one
    var accountCardAssets = new URL(url.href);
    accountCardAssets.pathname = accountCardAssets.pathname.replace("account-card", "synchrony");
    return accountCardAssets.href;
};
export default getSynchronyAssetsURL;
//# sourceMappingURL=getSynchronyAssetsURL.js.map